import { createContext } from "react";
import { Theme } from "../themeFiles/Theme";
import { UserColors } from "../colors/UserColors";
import { ThemeVersion } from "../themeFiles/ThemeVersion";
export const XDSContextWeb = createContext({
    theme: Theme.Dark,
    themeVersion: ThemeVersion.Polaris,
    isRtl: false,
    userColors: UserColors.XboxGreen,
    textScale: 1.0,
    version: "1.0",
    deviceOrientation: "portrait",
    deviceType: "Handset",
    language: ""
});
//# sourceMappingURL=XDSContextWeb.js.map